<template>
  <ul
    v-if="items && items.length > 0"
    :id="menuId"
    role="menu"
    :class="level > 0 ? 'mt-2' : ''"
  >
    <template v-for="(sectionItems, section) in groupedItems" :key="section">
      <li
        v-for="(child, index) in sectionItems"
        :key="getItemKey(child)"
        :class="[
          {
            'border-t-0.5 border-grey-7 dark:border-dark-border mt-4 pt-4':
              section !== 'undefined' && index === 0,
            'mb-2': index !== sectionItems.length - 1,
          },
        ]"
        role="none"
      >
        <!-- Render child item -->
        <AppSidebarNavItemRecursive
          :item="child"
          :level="level + 1"
        />
        
        <!-- Recursively render children if this item is expanded -->
        <AppSidebarSubmenuRecursive
          v-if="child.meta.is_expanded && child.children"
          :items="child.children"
          :level="level + 1"
          :menu-id="`submenu-${getItemKey(child)}`"
        />
      </li>
    </template>
  </ul>
</template>

<script setup>
import { computed } from 'vue'
import AppSidebarNavItemRecursive from './AppSidebarNavItemRecursive.vue'
import { useSidebarNavigation } from '../../../composables/useSidebarNavigation.js'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  level: {
    type: Number,
    default: 0,
  },
  menuId: {
    type: String,
    default: '',
  },
})

const { getItemKey } = useSidebarNavigation()

/**
 * Group items by section for visual separation
 */
const groupedItems = computed(() => {
  return props.items.reduce((acc, item) => {
    const section = item.meta.section || 'undefined'
    if (!acc[section]) {
      acc[section] = []
    }
    acc[section].push(item)
    return acc
  }, {})
})
</script>
